module.exports = __webpack_public_path__ + "media/src/images/zu_exp_01-847e4e28be1c7044c2c8be7ede950c6a.png";